'use client'

import { Spacer } from '@vinted/web-ui'

import { clickEvent } from '@marketplace-web/profile/profile-data'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { MEMBER_FOLLOWERS_URL, MEMBER_FOLLOWING_URL } from '../../../constants/routes'

type Props = {
  followersCount: number
  followingCount: number
  userId: number
  viewingSelf: boolean
}

const FollowInfo = ({ followersCount, followingCount, userId, viewingSelf }: Props) => {
  const translate = useTranslate('user')
  const { track } = useTracking()

  const followersURL = (id: number) => {
    return MEMBER_FOLLOWERS_URL(id)
  }

  const followingURL = (id: number) => {
    return MEMBER_FOLLOWING_URL(id)
  }

  const handleFollowClick = (target: Parameters<typeof clickEvent>[0]['target']) => {
    if (viewingSelf) track(clickEvent({ screen: 'current_user_profile', target }))
  }

  return (
    <div className="u-flexbox u-flex-wrap">
      <div className="u-flexbox">
        <a href={followersURL(userId)} onClick={() => handleFollowClick('followers')}>
          {followersCount}
        </a>
        <Spacer orientation="vertical" size="small" />
        {translate('followers', undefined, { count: followersCount })}
        <span>,</span>
        <Spacer orientation="vertical" size="small" />
      </div>
      <div className="u-flexbox">
        <a href={followingURL(userId)} onClick={() => handleFollowClick('following')}>
          {followingCount}
        </a>
        <Spacer orientation="vertical" size="small" />
        {translate('following', undefined, { count: followingCount })}
      </div>
    </div>
  )
}

export default FollowInfo
